import React from 'react'

const CancellationPolicy = () => {
  return (
    <div>CancellationPolicy</div>
  )
}

export default CancellationPolicy